export const IsIos = () => {
  if (!('navigator' in window)) return false;
  return navigator.userAgent.match(/ipad|iphone/i);
};
